class FiskalyController extends AbstractIntegrationController
	@register()
	@inject 'translate',
		'configuration'
		'configurationOptions'
		'shops'
		'IntegrationRepository'
		'ToastService'
		'CopyService'

	initialize: ->
		@tabs = [
			{
				title: 'general.details'
				selector: '#tab-details'
			}
			{
				title: 'general.information'
				selector: '#tab-information'
				disabled: !@configuration.is_active?
			}
		]

		id = @integrationId.replaceAll('_', '-')
		@fiscalizationTemplate = "@app/integration/#{id}/#{id}.fiscalization.view.html"

		@taxpayerTypes = [
			{id: 'INDIVIDUAL', name: @translate('wbo.integration.fiskaly.taxpayer.type.individual')}
			{id: 'COMPANY', name: @translate('wbo.integration.fiskaly.taxpayer.type.company')}
		]
		@reset(@configuration)

	save: ->
		configuration = @CopyService.copy @configuration

		if !@allowEditTaxpayer
			delete configuration.taxpayer

		super(configuration)
			.then (response) =>
				@reset(response.data)

	afterDisconnect: ->
		@reset()

	reset: (newConfiguration = {}) ->
		@configuration = newConfiguration
		@hasTaxpayer = @configuration.taxpayer_id?
		@allowEditTaxpayer = !@hasTaxpayer
		@tabs[1].disabled = !@configuration.is_active?
